import { post } from "@/services/http/platformServer";

/** 上传电子面单开通情况给平台（用于平台对加密分销订单是否开启了对应平台电子面单的认证） */
export function uploadEwaybillOpenStatus(shopId: number) {
    return post(shopId, "/alibaba/encrypted_out_order/upload_ewaybill_open_status", { shopId });
}
